"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrCookieDisclaimer = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const components_common_meta_modules_1 = require("@hotelplan/components.common.meta-modules");
const fdr_cookie_disclaimer_constants_1 = require("./fdr-cookie-disclaimer.constants");
const fdr_cookie_disclaimer_styles_1 = require("./fdr-cookie-disclaimer.styles");
function FdrCookieDisclaimer({ text, onAccept, }) {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const onAcceptCookiesConsent = (0, react_1.useCallback)(() => {
        js_cookie_1.default.set(components_common_meta_modules_1.COOKIES_CONSENT_COOKIE_NAME, fdr_cookie_disclaimer_constants_1.COOKIES_CONSENT_VALUE, {
            expires: fdr_cookie_disclaimer_constants_1.COOKIES_EXPIRATION_IN_DAYS,
        });
        (0, components_common_meta_modules_1.setBrowserMetaModulesContext)(Object.assign(Object.assign({}, (0, components_common_meta_modules_1.getBrowserMetaModulesContext)()), { hideCookieConsent: true }));
        onAccept === null || onAccept === void 0 ? void 0 : onAccept();
    }, [onAccept]);
    return (react_1.default.createElement(fdr_cookie_disclaimer_styles_1.CookiesDisclaimerWrapper, { "data-id": "cookiesDisclaimer" },
        react_1.default.createElement("div", { className: "cookies-disclaimer-text", dangerouslySetInnerHTML: { __html: text } }),
        react_1.default.createElement(fdr_cookie_disclaimer_styles_1.CookieAcceptButton, { onClick: onAcceptCookiesConsent, className: "cookies-disclaimer-button" }, t('common:accept.button'))));
}
exports.FdrCookieDisclaimer = FdrCookieDisclaimer;
//# sourceMappingURL=fdr-cookie-disclainer.js.map